export default __webpack_public_path__ + "static/media/referAFriendDesktop@2x.1fc4bf9d.png";